import httpClient from "./client";

export const createOrganization = async (organizationData) => {
  const response = await httpClient.post("/organizations/", organizationData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const getOrganizations = async () => {
  const response = await httpClient.get("/organizations/by-admin");
  return response;
};

export const updateOrganization = async (organizationId, organizationData) => {
  const response = await httpClient.put(
    `/organizations/${organizationId}`,
    organizationData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const deleteOrganization = async (organizationId) => {
  const response = await httpClient.delete(
    `/organizations/delete/${organizationId}`
  );
  return response;
};
